<ng-container *ngIf="phxIcon">
  <i phx-icon class="phx-badge-icon" [phxIcon]="phxIcon" [size]="iconSizes[phxSize]" color="currentColor"></i>
</ng-container>
<ng-container *ngIf="phxCount !== undefined || phxText">
  <span *ngIf="phxIntent !== 'calculating' && phxShape !== 'dot'" class="phx-badge-text">
    <ng-container *ngIf="isShowCount">
      {{ phxCount }}
    </ng-container>
    <ng-container *ngIf="phxText">
      {{ phxText }}
    </ng-container>
  </span>
</ng-container>
<ng-content></ng-content>
<ng-container *ngIf="phxIntent == 'calculating'">
  <i phx-icon class="phx-badge-icon" [phxIcon]='hourGlassIcon' [size]="20" color="currentColor"></i>
</ng-container>
<ng-container *ngIf="phxDismissible">
  <phx-divider class="phx-badge-dismiss-divider" phxOrientation="vertical" phxMarginX="none" [phxBackground]="dividerBackground"></phx-divider>
  <i class="phx-badge-dismiss-icon" phx-icon [phxIcon]="CloseIcon" [size]="closeIconSizes[phxSize]" color="currentColor" (click)="onBadgeDismiss()"></i>
</ng-container>